import { useTranslate } from "src/i18n";

export const useUnexpectedErrorTranslates = () => {
  const { t } = useTranslate();
  return {
    title: t("error_page.unexpected_error.title", "Технические работы"),
    description: t(
      "error_page.unexpected_error.description",
      "На сайте ведутся технические работы или произошла непредвиденная ошибка.<br />Пожалуйста, попробуйте обновить страницу позже или вернитесь на главную.",
    ),
    actionText: t("error_page.action_text", "На главную"),
  };
};
